
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/[[...id]]",
      function () {
        return require("private-next-pages/privacy/[[...id]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/[[...id]]"])
      });
    }
  